import React, { useMemo, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import DestroyMany, {
  DestroyManyRansack,
} from 'api/administration/monitoring/DestroyMany'
import ConfirmationModal from 'components/ui/modals/confirmation/ConfirmationModal'
import { CourseLmsProfileType } from 'enum'
import { CourseUser } from 'graphqlAPI'

const all = -1

const texts = {
  [all]: 'caution',
  [CourseLmsProfileType.Required]: 'warningRequired',
  [CourseLmsProfileType.Optional]: 'warningOptionalCantUndo',
}

const DeleteSelected: React.FC<{
  courseId: number | string
  className: string
  searchText: string
  count: number
  disabled?: boolean
  q: DestroyManyRansack
  ransackQueryGroup?: any
  onDeleted?: () => void
  selectedUsers: CourseUser[]
}> = ({
  courseId,
  className,
  searchText,
  count,
  disabled,
  q,
  onDeleted,
  selectedUsers,
  ransackQueryGroup,
}) => {
  const { t } = useTranslation()
  const prefix = 'administration.monitor.deleteSelected'
  const [showModal, setShowModal] = useState(false)

  const handleClose = () => {
    setShowModal(false)
  }

  const handleDelete = async () => {
    await DestroyMany(courseId, {
      search: searchText,
      q: {
        ...q,
        g: ransackQueryGroup,
      },
    })
    setShowModal(false)
    onDeleted?.()
  }

  const indexText = useMemo(() => {
    const mandatory = selectedUsers.every((u) => u.mandatory)
    if (mandatory) return CourseLmsProfileType.Required

    const optional = selectedUsers.every((u) => !u.mandatory)
    if (optional) return CourseLmsProfileType.Optional

    return all
  }, [selectedUsers])

  const text = t(`${prefix}.${texts[indexText]}`)

  return (
    <>
      <Dropdown.Item
        disabled={count < 1 || disabled}
        className={className}
        onClick={() => setShowModal(true)}
      >
        {t(`${prefix}.buttonShort`, {
          count: count,
        })}
      </Dropdown.Item>
      <ConfirmationModal
        show={showModal}
        title=""
        text={text}
        acceptButtonText={t('commons.buttons.destroy')}
        onAccept={() => handleDelete()}
        onClose={() => handleClose()}
      />
    </>
  )
}

export default DeleteSelected
